export const MINIMUM_MULTILEG_LEGS = 2;
export const MAXIMUM_MULTILEG_LEGS = 20;
